/**
 * HTTP-обёртки для /api/spaces/:id/automation-rules/* (FR-12).
 */
import { apiRequest } from '../../shared/api/client.ts';
import type {
  AutomationRule,
  AutomationRun,
  CreateAutomationRuleRequest,
  UpdateAutomationRuleRequest,
  RunAutomationNowResponse,
} from '@lens/shared';

export async function listAutomationRules(spaceId: string): Promise<AutomationRule[]> {
  const res = await apiRequest<{ items: AutomationRule[] }>(
    `/api/spaces/${spaceId}/automation-rules`,
  );
  return res.items;
}

export async function createAutomationRule(
  spaceId: string,
  body: CreateAutomationRuleRequest,
): Promise<AutomationRule> {
  return apiRequest<AutomationRule>(
    `/api/spaces/${spaceId}/automation-rules`,
    { method: 'POST', body },
  );
}

export async function updateAutomationRule(
  spaceId: string,
  ruleId: string,
  body: UpdateAutomationRuleRequest,
): Promise<AutomationRule> {
  return apiRequest<AutomationRule>(
    `/api/spaces/${spaceId}/automation-rules/${ruleId}`,
    { method: 'PUT', body },
  );
}

export async function deleteAutomationRule(spaceId: string, ruleId: string): Promise<void> {
  await apiRequest<void>(`/api/spaces/${spaceId}/automation-rules/${ruleId}`, {
    method: 'DELETE',
  });
}

export async function runAutomationNow(
  spaceId: string,
  ruleId: string,
): Promise<RunAutomationNowResponse> {
  return apiRequest<RunAutomationNowResponse>(
    `/api/spaces/${spaceId}/automation-rules/${ruleId}/run-now`,
    { method: 'POST' },
  );
}

export async function listAutomationRuns(
  spaceId: string,
  ruleId: string,
  limit = 30,
): Promise<AutomationRun[]> {
  const res = await apiRequest<{ runs: AutomationRun[] }>(
    `/api/spaces/${spaceId}/automation-rules/${ruleId}/runs?limit=${limit}`,
  );
  return res.runs;
}

export async function previewAutomationCron(
  spaceId: string,
  cronExpression: string,
  count = 3,
): Promise<{ runs: string[] }> {
  return apiRequest<{ runs: string[] }>(
    `/api/spaces/${spaceId}/automation-rules/preview-cron`,
    { method: 'POST', body: { cronExpression, count } },
  );
}
